<template>
    <div>
        <div v-for="statisExplItem in statisExplList" v-if="statisExplItem.theme === theme">
            <div class="form-single" v-for="statis in statisExplItem.explCon">
                <div class="title">{{ statis.label }}</div>
                <div class="content">
                    <label>{{ statis.value }}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    export default {
        name: 'swb-statis-fie-expl',
        props: ["theme"],
        data: function () {
            return {
                statisExplList: [
                    {
                        "theme": "故障维修趋势",
                        "explCon": [{
                            "label": "故障停用时间（天）：",
                            "value": "从扫码报修到服务验收完成，算一次故障停用时间；此处展示的是多次故障停用时间之和；"
                        }]
                    },
                    {
                        "theme": "设备运行报表",
                        "explCon": [{
                            "label": "故障率（%）：",
                            "value": "【出现故障的设备数量】/【设备总数量】"
                        }]
                    },
                    {
                        "theme": "设备维保统计",
                        "explCon": [{
                            "label": "使用时长（月）：",
                            "value": "设备启用时间到当前时间的时间差"
                        }, {
                            "label": "平均故障间隔（天）：",
                            "value": "【多次故障间隔时间之和】/【故障次数】"
                        }, {
                            "label": "平均维修时长（小时）：",
                            "value": "从第一次到达到服务完成（不包括服务暂停时长）算一次维修时长，【多次维修时长之和】/【维修次数】"
                        }, {
                            "label": "平均保养间隔（天）：",
                            "value": "【多次保养间隔时间之和】/【保养次数】"
                        }, {
                            "label": "平均保养时长（小时）：",
                            "value": "【多次保养时间之和】/【保养次数】"
                        }]
                    },
                    {
                        "theme": "服务商维保情况",
                        "explCon": [{
                            "label": "时间要求达成率（%）：",
                            // "value": "【时间区间内所有达成时间要求的工单数量】/【时间区间内所有有效工单数量】，根据要求修复时间与实际修复时长进行不对来判断是否达成时间要求"
                            "value": "预计完成时间 大于等于 实际完成时间 的工单 /  有效工单数量"
                        }, {
                            "label": "服务工时（小时）：",
                            "value": "到达服务现场与服务完成时间之差（不包括服务暂停时长）算一次服务工时，此处是时间区间内的多次服务工时之和；"
                        }, {
                            "label": "当日完工率（%）：",
                            "value": "【时间区间内所有当日完成工单数量】/【时间区间内所有有效工单出过发数量】，完工是以服务完成作为判断标准"
                        }]
                    },
                    {
                        "theme": "服务商分类维保情况",
                        "explCon": [{
                            "label": "时间要求达成率（%）：",
                            // "value": "【时间区间内指定分类设备所有达成时间要求的工单数量】/【时间区间内指定分类设备所有有效工单数量】，根据要求修复时间与实际修复时长进行不对来判断是否达成时间要求"
                            "value": "预计完成时间 大于等于 实际完成时间 的工单 /  有效工单数量"
                        }, {
                            "label": "服务工时（小时）：",
                            "value": "到达服务现场与服务完成时间之差（不包括服务暂停时长）算一次服务工时，此处是时间区间内的多次服务工时之和；"
                        }, {
                            "label": "当日完工率(%)",
                            "value": "【时间区间内所有当日完成工单数量】/【时间区间内所有有效工单出过发数量】，完工是以服务完成作为判断标准"
                        }]
                    }
                ]
            }
        },

    }
</script>
<style>

    .form-single .title {
        width: 155px;
        margin: 0;
    }

    .form-single .content {
        width: auto;
        padding-left: 160px;
    }
</style>




// WEBPACK FOOTER //
// src/compo/statisWork/statisFieExpl.vue